// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__Vxgch","logoWrapper":"Header_logoWrapper__+0fJP","wrapperNav":"Header_wrapperNav__5RLpX","selected":"Header_selected__o6uA3"};